export async function completeSca(purchaseId: string, paymentIntentClientSecret: string) {
	const stripe = window.Stripe(CK.config.environment.STRIPE_PUBLISHABLE_KEY);

	// @ts-ignore
	const { paymentIntent, error: retrievalError } = await stripe.retrievePaymentIntent(
		paymentIntentClientSecret
	);

	if (retrievalError) {
		throw retrievalError;
	}

	if (
		paymentIntent.status === 'requires_confirmation' ||
		paymentIntent.status === 'requires_action'
	) {
		const { error } = await stripe.handleCardPayment(paymentIntentClientSecret, {
			payment_method: paymentIntent.payment_method
		});

		if (error) {
			throw error;
		}
	}

	let isComplete: boolean = false;

	const MAX_SCA_COMPLETION_CHECK_POLLS = 24;

	for (let i = 0; i < MAX_SCA_COMPLETION_CHECK_POLLS; i++) {
		CK.logger.log('Checking for SCA completion, attempt', i, 'of', MAX_SCA_COMPLETION_CHECK_POLLS);
		isComplete = await CK.clientSockets.users.emit('checkScaCompletion', {
			purchaseId
		});

		if (isComplete) {
			break;
		}

		await Promise.delay(5000);
	}

	if (!isComplete) {
		CK.logger.critical('Failed to complete SCA at checkout');
		throw new Error(
			'We could not confirm your payment, if you believe payment has been taken in error, please contact support.'
		);
	}
}
